<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-sys__slproduct}">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
         <el-form-item>
          <el-input v-model="dataForm.productName" placeholder="产品名称" clearable></el-input>
        </el-form-item>
       
        <el-form-item >
    <el-select v-model="dataForm.productDockingMethod" filterable clearable placeholder="请选择产品对接方式">
        <el-option
                v-for="item in productMethodList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
        </el-option>
    </el-select>
    </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
        </el-form-item> -->
        <el-form-item>
          <el-button v-if="$hasPermission('wx:slproduct:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button v-if="$hasPermission('sys:slproduct:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item> -->
      </el-form>
      <el-table v-loading="dataListLoading"  :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="id" label="产品ID" header-align="center" align="center"></el-table-column>
        <el-table-column prop="productFlag" label="产品标识" header-align="center" align="center"></el-table-column>
      
        <el-table-column prop="productLogo" label="产品log" header-align="center" align="center">
          <template slot-scope="scope">
            <img class="logImg" :src="scope.row.productLogo" alt="产品log">
          </template>
        </el-table-column>
        <el-table-column prop="productName" label="产品名称" header-align="center" align="center"></el-table-column>
        <el-table-column prop="returnStatus" label="协议确认" header-align="center" align="center" >
          <template slot-scope="scope">
	           <span v-if="scope.row.returnStatus == 1">进件返</span>
             <span v-if="scope.row.returnStatus == 2">撞库返</span>
             <span v-if="scope.row.returnStatus == 3">全流程返</span>
        	</template>
        </el-table-column>
        <el-table-column prop="fistLevel" label="产品对接类型" header-align="center" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ getDictLabel1(scope.row.fistLevel) }}
          </template>
        </el-table-column>
        <el-table-column prop="bgPush" label="平推标识" header-align="center" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.bgPush == 1">是</span>
            <span v-if="scope.row.bgPush == 0">否</span>
          </template>
        </el-table-column>
        <el-table-column prop="productDockingMethod" label="产品对接方式" header-align="center" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ getDictLabel(scope.row.productDockingMethod) }}
          </template>
        </el-table-column>
        <el-table-column prop="bdPm" label="BD/PM" header-align="center" align="center"></el-table-column>
        <!-- <el-table-column prop="publishChannels" label="所属金融机构" header-align="center" align="center"></el-table-column> -->
        <el-table-column prop="companyName" label="公司名称" header-align="center" align="center"></el-table-column>
        <el-table-column prop="dailyLimit" label="每日限额" header-align="center" align="center"></el-table-column>
        <el-table-column prop="sellPrice" label="产品结算价格" header-align="center" align="center"></el-table-column>
        <!-- <el-table-column prop="buyPrice" label="购买价格" header-align="center" align="center"></el-table-column> -->
        <el-table-column prop="sort" label="排序编号" header-align="center" align="center"></el-table-column>
        <!-- <el-table-column prop="productName" label="产品状态" header-align="center" align="center"></el-table-column> -->

        <!-- <el-table-column prop="productCategory" label="产品大类" header-align="center" align="center">
          <template slot-scope="scope" >
            <div>
              {{ getText(scope.row.productCategory,1) }}
            </div>
          </template>
        </el-table-column> -->
        <!-- <el-table-column prop="productType" label="产品类型" header-align="center" align="center">
          <template slot-scope="scope" >
            <div>
              {{ getText(scope.row.productType,2) }}
            </div>
          </template>
        </el-table-column> -->
        <!-- <el-table-column prop="creditAmount" label="授信额度" header-align="center" align="center"></el-table-column> -->
        <!-- <el-table-column prop="maxRebate" label="最高返佣" header-align="center" align="center"></el-table-column> -->
        <!-- <el-table-column prop="productRate" label="产品利率" header-align="center" align="center"></el-table-column> -->
        <!-- <el-table-column prop="productLimit" label="产品期限" header-align="center" align="center"></el-table-column>
        <el-table-column prop="repaymentType" label="还款方式" header-align="center" align="center"></el-table-column>
        <el-table-column prop="productNotice" label="注意事项" header-align="center" align="center"></el-table-column>
        <el-table-column prop="productRequiredinfo" label="所需资料" header-align="center" align="center"></el-table-column>
        <el-table-column prop="productRebateInfo" label="返佣说明" header-align="center" align="center"></el-table-column>
        <el-table-column prop="productCompanyCondition" label="企业要求" header-align="center" align="center"></el-table-column>
        <el-table-column prop="productPersonCondition" label="个人要求" header-align="center" align="center"></el-table-column>
        <el-table-column prop="productCreditRequirement" label="征信要求" header-align="center" align="center"></el-table-column>
        <el-table-column prop="productOtherRequirement" label="其他要求" header-align="center" align="center"></el-table-column> -->
        <el-table-column prop="productAccessArea" label="准入区域" header-align="center" align="center">
          <template slot-scope="scope">
              <el-button  v-if="scope.row.productAccessArea !=='string' && scope.row.productAccessArea !==''" type="text" style="text-decoration: underline;" @click="handleReturnMsg(scope.row.productAccessArea)">准入区域</el-button>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="productApplyInfo" label="进件资料" header-align="center" align="center"></el-table-column>
        <el-table-column prop="productApplyFlow" label="进件流程" header-align="center" align="center"></el-table-column>
        <el-table-column prop="productOtherCondition" label="其它要求" header-align="center" align="center"></el-table-column>
        <el-table-column prop="productSettlementMode" label="产品结算方式" header-align="center" align="center"></el-table-column> -->
        <!-- <el-table-column prop="productIntro" label="产品简介" header-align="center" align="center"></el-table-column>
        <el-table-column prop="productExplain" label="产品说明" header-align="center" align="center"></el-table-column> -->
        <!-- <el-table-column prop="productLevel" label="产品等级 A-F" header-align="center" align="center"></el-table-column> -->
        <!-- <el-table-column prop="publishChannels" label="所属机构" header-align="center" align="center"></el-table-column>
        <el-table-column prop="channelPm" label="机构负责人" header-align="center" align="center"></el-table-column>
        <el-table-column prop="publishTime" label="发布时间" header-align="center" align="center"></el-table-column>
        <el-table-column prop="unshelveTime" label="下架时间" header-align="center" align="center"></el-table-column>
        <el-table-column prop="unshelveRemark" label="下架备注" header-align="center" align="center"></el-table-column>
        <el-table-column prop="creator" label="创建人" header-align="center" align="center"></el-table-column> -->
        <el-table-column prop="createDate" label="创建时间" header-align="center" align="center"></el-table-column>
        <el-table-column prop="loanTerm" label="有效期" header-align="center" align="center"></el-table-column>

        <!-- <el-table-column prop="updateBy" label="更新人" header-align="center" align="center"></el-table-column>
        <el-table-column prop="updateTime" label="更新日期" header-align="center" align="center"></el-table-column>
        <el-table-column prop="deleteTime" label="删除日期" header-align="center" align="center"></el-table-column> -->
        <!-- <el-table-column prop="产品状态" label="状态" header-align="center" align="center">
          <template slot-scope="scope">
            <span  v-if="scope.row.status == 1">启用</span>
            <span v-if="scope.row.status == 0" style="color: rgb(245,108,108);">禁用</span>
          </template>
        </el-table-column> -->
        <el-table-column label="状态" header-align="center" align="center">
          <template slot-scope="scope">
            <span  v-if="scope.row.productShow == 1">上架</span>
            <span  v-if="scope.row.productShow == 0" style="color: rgb(245,108,108);">下架</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('wx:slproduct:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>
            <el-button v-if="$hasPermission('wx:slproduct:data')" type="text" size="small" @click="$router.push('/wx-entry')">数据</el-button>
            <!-- <el-button v-if="$hasPermission('sys:slproduct:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button> -->
          </template>
        </el-table-column>
        <el-table-column prop="" label="日志" header-align="center" align="center">
          <template slot-scope="scope">
            <el-button  v-if="$hasPermission('wx:slproduct:log')"   type="text" size="small" @click="$router.push('/sys-slproductlog')">日志</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <el-dialog
      title="返回信息"
      :visible.sync="dialogVisible"
      width="30%"
     >
      <span v-html="returnedMessagesVal"></span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './slproduct-add-or-update'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/sys/slproduct/page',
        getDataListIsPage: true,
        exportURL: '/sys/slproduct/export',
        deleteURL: '/sys/slproduct',
        deleteIsBatch: true
      },

      returnedMessagesVal: '',
      dialogVisible: false,
      productTypeList: [],
      productCategories: [],
      productNames: [],
      productMethodList:[],
      productFirstList:[],
      dataForm: {
        id: '',
        userType: '',
      }
    }
  },
  created(){
    this.getproductCategoriesOptions()
    this.getProductTypeOptions()
    // this.getproductNameOptions()
    this.getProductMethods();
    // this.getproductTypesFirst()
  },
  methods: {
    //初始化产品对接方式
    async getProductMethods() {
      this.$http.get(`/sys/dict/data/list?dataType=productDockingMethod`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        if (res.data!=null){
          res.data.forEach(element => {
            this.productMethodList.push({label:element.dictLabel,value:element.dictValue})
          })
        }
      }).catch(() => {})
    },
     // 产品对接类型
     async getproductTypesFirst() {
      this.$http.get(`/sys/dict/data/list?dataType=product_first_type`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }

        this.productFirstList = [];
        if (res.data != null) {
          res.data.forEach(element => {
            this.productFirstList.push({ label: element.dictLabel, value: element.dictValue })
          })
        }
      }).catch(() => { })
    },
    getDictLabel(value) {
      const dictItem = this.productMethodList.find(item => item.value === value);
      return dictItem ? dictItem.label : ''; // 返回对应的 label 或空字符串
    },
    getDictLabel1(value) {
      const dictItem = this.productFirstList.find(item => item.value === value);
      return dictItem ? dictItem.label : ''; // 返回对应的 label 或空字符串
    },
    getText(txt,n){
      if(n == 1){
        return this.productCategories.filter(item => item.value == txt)[0]?.label
      }else{
        return this.productTypeList.filter(item => item.value == txt)[0]?.label
      }
    },
   
     //初始产品名称下拉框中的选项
   async getproductNameOptions() {
           this.$http.get(`/sys/dict/data/list?dataType=productName`).then(({ data: res }) => {
              if (res.code !== 0) {
                  return this.$message.error(res.msg)
              }
              this.productNames = [];
              if (res.data!=null){
                  res.data.forEach(element => {
                      this.productNames.push({label:element.dictLabel,value:element.dictValue})
                  })
              }
          }).catch(() => {})
      },
      async getProductTypeOptions() {
          this.$http.get(`/sys/dict/data/list?dataType=product_type`).then(({ data: res }) => {
              if (res.code !== 0) {
                  return this.$message.error(res.msg)
              }
               this.productTypeList = [];
              if (res.data!=null){
                  res.data.forEach(element => {
                   this.productTypeList.push({label: element.dictLabel ,value: element.dictValue})
                  })
              }
          }).catch(() => {})
      },
  
    async getproductCategoriesOptions() {
          this.$http.get(`/sys/dict/data/list?dataType=product_categories`).then(({ data: res }) => {
              if (res.code !== 0) {
                  return this.$message.error(res.msg)
              }
               this.productCategories = [];
              if (res.data!=null){
                  res.data.forEach(element => {
                   this.productCategories.push({label: element.dictLabel ,value: element.dictValue})
                  })
              }
          }).catch(() => {})
      },
      // async getProductTypeOptions() {
      //     this.$http.get(`/sys/dict/data/list?dataType=product_type`).then(({ data: res }) => {
      //         if (res.code !== 0) {
      //             return this.$message.error(res.msg)
      //         }
      //          this.productTypeList = [];
      //         if (res.data!=null){
      //             res.data.forEach(element => {
      //              this.productTypeList.push({label: element.dictLabel ,value: element.dictValue})
      //             })
      //         }
      //     }).catch(() => {})
      // },
      handleReturnMsg(returnMsg){
        let arr = ''
        JSON.parse(returnMsg).provinces.forEach(item => {
          if(item.istrue){
              arr += `<br/>${item.name}: `
          }
          item.cities.forEach(item1 => {
            if(item1.istrue){
              arr += `${item1.name} `
            }
          })
          
        })
        // console.log(...arr)
        this.returnedMessagesVal = arr
    
      this.$nextTick(() =>{
        this.dialogVisible = true;
        // this.returnedMessagesVal = returnMsg
      })
    },
  },
  components: {
    AddOrUpdate
  }
}
</script>
<style scoped>
.logImg{
  width: 50px;
  height: 50px;
}
</style>